var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spinner',{attrs:{"size":20,"line-fg-color":"#5ad691"}})}
var staticRenderFns = []

export { render, staticRenderFns }